<template>
    <div class="selector" :class="{ active: isOpen }">
        <div v-if="children.length >= 10" class="quick-search"><input type="text" name="search" placeholder="Search Children"><span class="fa fa-search"></span></div>
        <a :href="`/settings/children/select/${ child.id }/back`" v-for="child in availableChildren" :key="`child-${ child.id }`" class="child">
            <div class="child-nav">
                <div class="child-info">
                    <div class="logged-in-as">{{ child.first_name }}</div>
                    <div class="job-title"><span class="tag-bubble" :class="childLevelClass(child)">Level {{ child.level || 'N/A' }}</span></div>
                </div>
                <div class="avatar">
                    <div class="profile-photo" :style="`background:url('${ thumbnail(child) }') center center no-repeat; background-size:cover;`"></div>
                </div>
            </div>
        </a>
        <a href="/settings/children" class="add-button">{{ buttonText }} <span class="fa" :class="buttonIcon"></span></a>
    </div>
</template>

<script>

import { mapState } from 'vuex';
import _ from 'underscore';
import ChildMixin from '@/mixins/ChildMixin';

export default {

    mixins: [ ChildMixin ],

    computed: {
        activeChild() {
            return _.findWhere(this.children, { id: this.activeChildId });
        },

        ...mapState({
            children: state => state.children,
            activeChildId: state => state.activeChildId,
            isOpen: state => state.childSelectorOpen,
        }),

        availableChildren() {
            return _.filter(this.children, (child) => {
                return child.id !== this.activeChildId;
            });
        },

        buttonText() {
            if (this.children.length === 0) {
                return 'Add A Child';
            } else if (this.children.length <= 1 ) {
                return 'Add Another Child';
            }

            return 'Manage Your Children';
        },

        buttonIcon() {
            if (this.children.length <= 1 ) {
                return 'fa-plus';
            }

            return 'fa-cog';
        },
    },


}

</script>



// WEBPACK FOOTER //
// resources/js/components/layouts/ChildSelector.vue